import { render } from "./UsersStatistics.vue?vue&type=template&id=c6bc5de6"
import script from "./UsersStatistics.vue?vue&type=script&lang=js"
export * from "./UsersStatistics.vue?vue&type=script&lang=js"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__